/**
 * Step 6: RFP Preview - Review generated RFP document
 */
import { useWizard } from './WizardContext';
import GenerationLock from './GenerationLock';
import { RegeneratedNotice } from './WizardBanners';
import RfpPreview from '@/components/RfpPreview';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft, Loader2 } from 'lucide-react';

const StepRfpPreview = () => {
  const {
    loading,
    procurementId,
    rfpDocument,
    refinedRequirement,
    serialId,
    rfpVersion,
    lineItems,
    attachedDocuments,
    setCurrentStep,
    handleProceedToRisk,
    regeneratedNotice
  } = useWizard();

  return (
    <div className="relative">
      <GenerationLock active={loading} message="Generating risk intelligence — please wait" />
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-zinc-900 mb-2">
          RFP Document
        </h2>
        <p className="text-zinc-600">
          Review and download the generated RFP.
        </p>
      </div>

      {regeneratedNotice?.stepId === 'rfp' && (
        <RegeneratedNotice causeLabel={regeneratedNotice.causeLabel} />
      )}

      <RfpPreview
        rfpDocument={rfpDocument}
        procurementId={procurementId}
        refinedRequirement={refinedRequirement}
        serialId={serialId}
        rfpVersion={rfpVersion}
        procurementLineItems={lineItems}
        attachedDocuments={attachedDocuments}
        isCompletionStep={false}
      />
      
      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={() => setCurrentStep(4)} disabled={loading} className="border-zinc-200">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Button>
        <Button 
          onClick={handleProceedToRisk} 
          disabled={loading} 
          className="bg-[#0055FF] hover:bg-[#0044CC] text-white px-6" 
          data-testid="proceed-to-risk-btn"
        >
          {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ArrowRight className="w-4 h-4 mr-2" />}
          {loading ? 'Generating Risk Intelligence...' : 'Generate Risk Intelligence'}
        </Button>
      </div>
    </div>
  );
};

export default StepRfpPreview;
